<div id="wrapper" class="h-100vh p-3">
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column ml-0">
      <!-- Main Content -->
      <div id="content">
        <div class="container-fluid">
          <div class="row logo">
            <div class="col-12 row no-gutters justify-content-center">
              <h1
                class="d-flex justify-content-center"
                style="flex-direction: column; align-items: center"
              >
                <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
              </h1>
            </div>
          </div>

          <div class="row" style="letter-spacing: 0">
            <form
              (submit)="changePassword()"
              class="col-12 user-form-reset mx-auto center-block mt-5"
            >
              <input
                type="hidden"
                name="_token"
                value="4gMwbicnRlsLpqtDdCdBYSg6BzWa5iay6srhgwdQ"
              />

              <div
                *ngIf="page === 'password-reset-send'"
                class="row no-gutters mx-auto error-message"
              >
                <div class="col-md-12">
                  <div class="alert alert-success" role="alert">
                    パスワードリセットリンクをメールで送信しました。
                  </div>
                </div>
              </div>
              <div
                *ngIf="errorMessages.forgetpassword.email"
                class="row no-gutters mx-auto"
                style="max-width: 300px"
              >
                <div class="col-md-12">
                  <div class="alert alert-danger" role="alert">
                    <ul class="m-0">
                      <li>メールアドレスを入力してください。</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group justify-content-center">
                  <label
                    class="col-form-label"
                    for="email"
                    style="font-size: 16px !important"
                    >メールアドレス</label
                  >
                </div>
                <div class="input-group justify-content-center">
                  <input
                    [(ngModel)]="email"
                    type="text"
                    class="form-control"
                    id="email"
                    name="email"
                    placeholder="メールアドレス"
                    value=""
                    autofocus=""
                    aria-describedby="email-help"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-12 text-center mt-3">
                  <button type="submit" class="btn px-3 mb-3">
                    パスワードリセット</button
                  ><br />
                  <a (click)="navigate('login')" style="cursor: pointer"
                    >ログイン</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
